import React from 'react'
import customer from "../../imagens/logos/logoAmplicabos.png"
import customer5 from "../../imagens/logos/logoBosch.png"
import customer2 from "../../imagens/logos/logoDenso.jpg"
import customer3 from "../../imagens/logos/logoContinental.png"
import customer4 from "../../imagens/logos/logoSriko.png"
import Header from '../../Components/Header'
import Customers from '../../Components/customers'


const listCustomer = [
    {
        img: customer5
    },
    {
        img: customer
    },
    {
        img: customer2
    },
    {
        img: customer3
    },
    {
        img: customer4
    }
]






const CustomersPage = () => {
return (
    <div>
        <Header/>
            <Customers
                listCustomer = {listCustomer}
            />
    </div>
)
}

export default CustomersPage